var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles } from "@material-ui/core";
import React from "react";
import { typography } from "../../shared/theme";
export const FTLTableCell = React.forwardRef((_a, ref) => {
    var { type = "default", textAlign, action, isDisabled, isFocusable, minWidth, className = "" } = _a, otherProps = __rest(_a, ["type", "textAlign", "action", "isDisabled", "isFocusable", "minWidth", "className"]);
    const { basic, head } = useStyles({
        textAlign,
        isDisabled,
        isFocusable,
        minWidth,
    });
    if (type === "default")
        return (React.createElement("td", Object.assign({ ref: ref, className: className + " " + basic }, otherProps, { tabIndex: -1 })));
    else
        return (React.createElement("th", Object.assign({ ref: ref, className: className + " " + head }, otherProps, { tabIndex: !isFocusable ? -1 : undefined })));
});
const useStyles = makeStyles((theme) => ({
    basic: ({ textAlign, isDisabled, }) => (Object.assign({ padding: 8, verticalAlign: "top", "& > .MuiIconButton-root": {
            padding: 0,
        }, whiteSpace: "pre-wrap", wordBreak: "break-word", textAlign, boxShadow: "inset 0 -1px 0 0 #EBEDF0", color: isDisabled ? theme.palette.text.disable : theme.palette.text.primary, outline: "none", boxSizing: "border-box" }, typography.unsupportedSemanticTags.listItemText)),
    head: ({ textAlign = "left", isFocusable, minWidth, }) => {
        const styles = Object.assign({ color: theme.palette.text.tertiary, padding: 8, margin: 0, textAlign,
            minWidth, outline: "none", verticalAlign: "middle", boxShadow: "inset 0 -2px 0 0 #EBEDF0", boxSizing: "border-box" }, typography.supportedTags.h5);
        if (isFocusable)
            return Object.assign(Object.assign({}, styles), { "&:hover": {
                    backgroundColor: "#f5f5f6",
                }, "&:active": {
                    backgroundColor: "#f0f1f1",
                }, "&:focus": {
                    backgroundColor: "#fff",
                    boxShadow: `inset 0 0 0 2px ${theme.palette.border.focus}`,
                } });
        return styles;
    },
}));
//# sourceMappingURL=FTLTableCell.js.map